const isSpecialHoliday = (new Date().getMonth() === 0 && new Date().getDate() === 1) || (new Date().getMonth() === 11 && new Date().getDate() === 25);

export default isSpecialHoliday;
